module.exports = __webpack_public_path__ + "static/media/step3c.432b73a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tour/assets/step3c.png
// module id = 3739
// module chunks = 0